import { useDispatch } from 'react-redux';

import { CustomTabs } from '../../../shared/uiComponents';
import DSUNotes from './DSUNotes';
import { Container } from './helpers';
import SOAPNotes from './SOAPNotes';

import { DispatchProperties } from '../../../redux/store';
import { clearFilterData } from '../../../redux/State/clientSlice/billingSlice';
import { PageHeader } from '../../../components/PageHeader';
import { Notes } from '../../../shared/Assets/menuIcons';

const HEADERS = ['All notes', 'DSU notes'];

const PANELS = [SOAPNotes, DSUNotes];

const AdminSOAPNotes = () => {
	const dispatch = useDispatch<DispatchProperties>();

	const clearFilters = () => dispatch(clearFilterData());

	return (
		<Container>
			<PageHeader icon={<Notes />} title="SOAP Notes" isInContainer customStyles={{ marginBottom: '24px' }} />
			<CustomTabs headers={HEADERS} panels={PANELS} onHeaderClick={clearFilters} className="marginBottom16" />
		</Container>
	);
};

export default AdminSOAPNotes;
